import { Outlet } from "react-router-dom";

export default function WholeSaleOrder() {
  return (
    <Outlet />
  );
}
